export const environment = {
  production: false,
  apiUrl: 'https://api-hml.cuidazap.com/api',
};
